
import Vue from 'vue'
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)
import { openServiceAuth } from '@/settings'
import { mapGetters } from 'vuex'
import getPageTitle from '@/utils/get-page-title'
import { copyToClip } from '~/utils/index.js'

export default {
    data() {
        return {
            serviceData: [],
            gameName: null,
            buyType: null,
            titleBoxName: null,
            isDisabled: false,
            dealerList: [],
            releaseData: {},
            dialogVisible: false,
            sellerCenterList: [],
            pageInfo: {
                totalPages: 0,
                page: 1,
                pageSize: 10
            },
            recycleData: {},
        }
    },
    metaInfo() {
        return {
            title: `${getPageTitle(this.titleBoxName + '列表')}`
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            token: 'user/token',
            releaseDataObj: 'game/releaseDataObj'
        })
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        copySuccess(val) {
            copyToClip(val, '已复制')
        },
        join(e) {
            // let par = {
            //     action: {
            //         status: 'ON_STAND'
            //     },
            //     page: 1,
            //     pageSize: 10
            // }
            // this.recycleData = e;
            // this.$api.sellerCenter(par).then(res => {
            //     if (!res.success) {
            //         this.$message.error(res.info)
            //         return
            //     }
            //     this.sellerCenterList = res.data.records;
            //     this.pageInfo.totalPages = Number(res.data.totalPages);
            //     this.dialogVisible = true;
            // })
            // 批量上传埋点。触发6次统计一个周期
            this.$store.dispatch('tracking/PointList', { event: 'PROXY_LIST_CONSULT_RECOVERY', eventId: `${this.recycleData.userId}_${this.$route.params.id}` })
            // 回收位埋点
            this.$trackEvent({
                eventType: 'click',
                trackParams: {
                    eventName: '回收-去咨询',
                    gameId: this.$route.params.id,
                    pageAccessSource:this.$route.params.pageAccessSource
                }
            })
            if (openServiceAuth && !this.token) {
                this.$message.warning('请先登录')
                this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
                return
            }
            this.$api.recycleConsult({
                id: e.userId,
                nickname: e.nickname,
                gameId: this.$route.params.id
            })
            .then(res => {
                if (!res.success) {
                    return this.$message.error(res.info)
                }
                // 需求：https://devops.aliyun.com/projex/project/8fcc522a515189d26340126b69/req/f286d70e2cabceec05106fce56
                const d = {
                    eventName: '回收页面-去咨询',
                    gameId: Number(this.$route.params.id),
                    sessionId: res.data
                }
                this.$trackEvent({
                    eventType: 'click',
                    trackParams: d
                })
                
                this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
                
                // 保存号商信息，用于埋点
                this.$store.commit('ry/SET_RECYCLE_MERCHANT_INFO', {
                    merchantId: e.userId,
                    gameId: this.$route.params.id,
                    targetId: res.data    
                })
                
                let data = {
                    targetId: res.data,
                    conversationType: 3
                }
                
                // console.log(this.$route.params.type, '~~~~~~~~~~~~~~~~~~~~~~~~~~~111111')
                // if (this.$route.params.type) {
                //     data.type = 1
                //     this.$store.commit('ry/SET_GLOBAL_SHOW_COMMODITY', true)
                // }
                this.$store.dispatch('ry/join', data)
                this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                this.$store.commit('ry/SET_ORDER_FLOW', [])
                this.dialogVisible = false;
            })
        },
        // 去咨询
        sendGoodsCard(val) {
            // 批量上传埋点。触发6次统计一个周期
            this.$store.dispatch('tracking/PointList', { event: 'PROXY_LIST_CONSULT_RECOVERY', eventId: `${this.recycleData.userId}_${this.$route.params.id}` })
            if (openServiceAuth && !this.token) {
                this.$message.warning('请先登录')
                this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
                return
            }
            this.$api.recycleConsult({
                id: this.recycleData.userId,
                nickname: this.recycleData.nickname,
                goodsNo: val.goodsNo
            })
            .then(res => {
                if (!res.success) {
                    return this.$message.error(res.info)
                }
                this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
                
                // 保存回收号商信息，用于埋点
                this.$store.commit('ry/SET_RECYCLE_MERCHANT_INFO', {
                    merchantId: this.recycleData.userId,
                    gameId: this.$route.params.id,
                    targetId: res.data    
                })
                
                let data = {
                    targetId: res.data,
                    conversationType: 3
                }
                // console.log(this.$route.params.type, '~~~~~~~~~~~~~~~~~~~~~~~~~~~111111')
                // if (this.$route.params.type) {
                //     data.type = 1
                //     this.$store.commit('ry/SET_GLOBAL_SHOW_COMMODITY', true)
                // }
                this.$store.dispatch('ry/join', data)
                this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                this.$store.commit('ry/SET_ORDER_FLOW', [])
                this.dialogVisible = false;
            })
        },
        scrollFlipPage() {
            if (this.pageInfo.totalPages <= this.pageInfo.page) return
            this.pageInfo.page++
            let par = {
                action: {
                    status: 'ON_STAND'
                },
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            this.$api.sellerCenter(par).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.sellerCenterList.push(res.data.records);
            })
        },
        getImList() {
            let p = {
                action: {
                    gameId: parseInt(this.$route.params.id),
                    goodsCatalogueId: this.$route.params.goodsCatalogueId,
                    linkType: this.buyType
                }
            }
            if (this.buyType == 'RECOVERY') {
                p.action.goodsCatalogueId = 6
            }
            this.$api.getImList(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.serviceData = res.data
            })
        },

        getService() {
            this.$api.recyclePermissionList(parseInt(this.$route.params.id)).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.dealerList = res.data
            })
        }
    },
    mounted() {
        this.buyType = this.$route.params.buyType
        this.titleBoxName = '合作商'
        this.gameName = this.$route.params.name
        this.$trackEvent({
                eventType: 'pageView',
                trackParams: {
                    eventName: '回收合作商页面访问来源',
                    gameId: this.$route.params.id,
                    pageAccessSource:this.$route.params.pageAccessSource
                }
            })
        // this.releaseData = this.releaseDataObj[this.releaseDataObj?.currentId] || {}
        const recyclePar = {
            action:{
                gameId: this.$route.params.id,
                goodsCatalogueId: 6
            }
        }
        this.$api.gameAll(recyclePar).then(res => {
            if (!res.success) {
                this.$message.error(res.info)
                return
            }
            this.releaseData = res.data ? res.data[0] : {}
        })
        this.getImList()
        let serviceData = sessionStorage.getItem(`serviceData-${this.buyType}`)
        if (this.buyType == 'RECOVERY') {
            this.getService()
        }

        // 如果 sessionStorage 里面有值就从里面取否则重新请求接口，是为了有人想从链接点击进来
        if (serviceData) {
            this.serviceData = JSON.parse(serviceData)
            return
        }
    },
    destroyed() {
        sessionStorage.removeItem(`serviceData-${this.buyType}`)
    }
}
